import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { EnvelopeSimple } from 'phosphor-react';

import { startForgotPasswordPage, sendLinkByEmail } from 'redux/actions/pages';
import AuthShell from './home-components/AuthShell';
import FormField from './home-components/FormField';
import CustomAlert from './CustomAlert';
import CustomLoading from './CustomLoading';

const ForgotPassword = ({
  redirectTo,
  startForgotPasswordPage,
  sendLinkByEmail,
}) => {
  const [email, setEmail] = useState('');

  const history = useHistory();

  useEffect(() => {
    startForgotPasswordPage();
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (redirectTo && redirectTo !== '' && redirectTo !== '/create-password') {
      history.push(redirectTo);
    }
    // eslint-disable-next-line
  }, [redirectTo]);

  const onSendLinkByEmailClick = (e) => {
    e.preventDefault();
    sendLinkByEmail({ email });
  };

  return (
    <>
      <CustomAlert />
      <CustomLoading />
      <AuthShell
        path="/forgot-password"
        asideTitle="Birkaç adımda yeni şifre"
        aside={
          <>
            <ol className="op-auth__steps">
              <li>Hesabına kayıtlı e-posta adresini yaz.</li>
              <li>Gelen e-postadaki bağlantıya tıkla.</li>
              <li>Yeni şifreni belirle ve giriş yap.</li>
            </ol>
            <p className="op-auth__hint">
              E-posta adresin kayıtlı değilse öğretmenine ya da okul
              yöneticine başvurabilirsin.
            </p>
          </>
        }
      >
        <span className="op-kicker">Şifremi unuttum</span>
        <h1>Şifreni mi unuttun?</h1>
        <p className="op-auth__lead">
          Endişelenme! E-posta adresini yaz, sana yeni şifre oluşturma
          bağlantısı gönderelim.
        </p>
        <form className="op-auth__form" method="post" onSubmit={onSendLinkByEmailClick}>
          <FormField id="forgot-email" label="E-posta" icon={EnvelopeSimple}>
            <input
              id="forgot-email"
              type="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormField>
          <button className="op-btn op-btn--primary op-btn--lg op-auth__submit" type="submit">
            Bağlantı Gönder
          </button>
        </form>
        <p className="op-auth__foot">
          <a href="/signin">← Giriş ekranına dön</a>
        </p>
      </AuthShell>
    </>
  );
};

const mapStateToProps = (state) => ({
  redirectTo: state.ui.redirectTo,
});

const mapDispatchToProps = {
  startForgotPasswordPage,
  sendLinkByEmail,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
